{
  "cancel": "Cancel",
  "save": "Save",
  "create": "Create",
  "delete": "Delete",
  "edit": "Edit",
  "close": "Close",
  "confirm": "Confirm",
  "yes": "Yes",
  "no": "No",
  "loading": "Loading…",
  "error": "Error",
  "success": "Success",
  "search": "Search",
  "filter": "Filter",
  "refresh": "Refresh",
  "back": "Back",
  "language": "Language",
  "english": "English",
  "french": "Français",
  "loading_module": "loading module…",
  "relative_time": {
    "just_now": "just now",
    "seconds_ago": "{{n}}s ago",
    "minutes_ago": "{{n}} min ago",
    "hours_ago": "{{n}}h ago"
  },
  "open_ip_view": "Open IP view for {{ip}}"
}
